import { BetterBeOption, BetterBeWidgetPayload } from '../betterBe/betterBePayload.model';
import { debugLog } from '../common/miscUtils';
import { betterBeOptionTypeToWebCalc } from './enums';
import { WebCalcRequest, WebCalcRequestVehicleOption } from './webCalcRequest.model';

const POS_DOMAIN = 'POS.IE';
const IS_EXCLUDING_VAT = false;

const mapOption = (option: BetterBeOption): WebCalcRequestVehicleOption => {
  const webCalcType = betterBeOptionTypeToWebCalc[option.type];
  if (!webCalcType) {
    debugLog({ level: 'ERROR', message: `[WebCalc] unmapped BetterBe option type: "${option.type}"` });
  }

  const optionPrice = IS_EXCLUDING_VAT ? option.price.basePrice : option.price.retailPrice;

  return {
    id: String(option.optionId),
    prKey: option.orderCode,
    ...(webCalcType ? { type: webCalcType } : {}),
    ...(optionPrice == null ? {} : { optionPriceAmount: { amount: optionPrice } }),
  };
};

export const mapBetterBeToWebCalcRequest = (payload: BetterBeWidgetPayload): WebCalcRequest => {
  const vehicleId = payload.vehicle.catalogVehicle?.vehicleId;
  if (vehicleId == null) {
    debugLog({
      level: 'ERROR',
      message: '[WebCalc] BetterBe payload has no catalogVehicle.vehicleId; vehicle.model.code is empty.',
    });
  }

  const vehiclePrice = IS_EXCLUDING_VAT ? payload.price.amountEx : payload.price.amountInc;

  return {
    context: { domain: POS_DOMAIN },
    vehicle: {
      model: {
        code: vehicleId == null ? undefined : String(vehicleId),
        codeType: 'BLS',
        options: payload.vehicle.options.map(mapOption),
      },
      isUsed: false,
      baseModelPriceAmount: { amount: vehiclePrice },
      retailPriceAmount: { amount: vehiclePrice },
      priceDetails: { isExcludingVAT: IS_EXCLUDING_VAT },
    },
  };
};
